import PromotionalCard from '@ulta/components/PromotionalCard/PromotionalCard';

export default PromotionalCard;
